import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const FormWrapper = styled(Flex)`
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
  `}
`;

export const ButtonWrapper = styled(Box)`
  margin-left: auto;
  margin-right: auto;
`;
